<template>
  <div
    :class="componentClasses"
  >
    <div class="stk-detail-label">
      {{ label }}
    </div>

    <div
      v-if="value"
      class="stk-detail-value"
    >
      {{ value }}
    </div>

    <div
      v-else
      class="stk-detail-value"
    >
      <slot />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: {
    type: String,
  },
  value: {
    type: String,
  },
  variant: {
    type: String,
  },
});
const componentClasses = computed(() => [
  'stk-detail',
  { [`is-${props.variant}`]: props.variant },
]);
</script>

<style>
.stk-detail {
  display: flex;
  font-size: 0.875em;
  align-items: start;
  gap: 1em;

  &.is-vertical {
    flex-direction: column;
    gap: 0;

    .stk-detail-label {
      width: auto;
    }
  }

  &.is-heading {
    font-style: italic;
  }
}

.stk-detail-label,
.stk-detail-value {
  font-weight: 500;
}

.stk-detail-label {
  color: var(--stk-text-weak);
  flex-shrink: 0;
  width: 8em;
}

.stk-detail-value {
  flex-grow: 1;
  color: var(--stk-text-strong);
}
</style>
